import handleToggle from '../common/handleToggle';

/**
 * Attach interactions to every element that matches selector.
 */
$('.collapsible').each((_, component) => {
    $(component).on('click', '.collapsible__head', handleToggle(component));
});



// WEBPACK FOOTER //
// ./src/scripts/components/collapsible/index.js